import React from "react";
import { NavLink } from "react-router-dom";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreIcon from "@material-ui/icons/MoreVert";

import styles from "./styles";

export default function ResortMenu(props) {
	const classes = styles();
	const { resort } = props;
	const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);
	const handleMobileMenuClose = () => {
		setMobileMoreAnchorEl(null);
	};
	const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
	const mobileMenuId = "primary-search-account-menu-mobile";
	const handleMobileMenuOpen = (event) => {
		setMobileMoreAnchorEl(event.currentTarget);
	};

	const renderMobileMenu = (
		<Menu
			anchorEl={mobileMoreAnchorEl}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			id={mobileMenuId}
			keepMounted
			transformOrigin={{ vertical: "top", horizontal: "right" }}
			open={isMobileMenuOpen}
			onClose={handleMobileMenuClose}
		>
            {resort && resort.menus && resort.menus.length && 
                resort.menus.map((menu, key) => (
                    <MenuItem key={key} >
                        <NavLink to={`/${menu.slug}/${resort.slug}`} >{menu.value}</NavLink>
                    </MenuItem>
                ))
            }
		</Menu>
	);
	return (
		<React.Fragment>
			<div className={classes.menu}>
				<div className={classes.root}>
					<ul>
                    {resort && resort.menus && resort.menus.length && 
                        resort.menus.map((menu, key) => (
						<li key={key} >
							<NavLink to={`/${menu.slug}/${resort.slug}`}>{menu.value}</NavLink>
						</li>
                        ))
                    }
					</ul>
				</div>
			</div>
			<div className={classes.sectionMobile}>
				<IconButton
					aria-label="show more"
					aria-controls={mobileMenuId}
					aria-haspopup="true"
					onClick={handleMobileMenuOpen}
					color="inherit"
				>
					<MoreIcon />
				</IconButton>
			</div>
			{renderMobileMenu}
		</React.Fragment>
	);
}
